<h3 *ngIf="errorTexts" class="channels-error-title">{{ errorTexts.TITLE | translate}}</h3>
<h3 *ngIf="!errorTexts" class="channels-error-title" translate>ERROR.REGISTER</h3>
<h3  class="channels-error-code">{{ code }}</h3>
<div *ngIf="errorTexts" (click)="contactSupport()" class="channels-error-description">
  <p>{{ errorTexts.CONTENT | translate}}</p>
</div>
<button class="btn channels-button" (click)="contactSupport()">{{'CHANNELS.ERROR_PAGE.CTA' | translate}}
</button>
